<template>
  <div class="representation d-flex flex-column">
    <v-container v-if="!loading && disableMessage == null">
      <h1>
        {{
          oracle.translate('برای شروع همکاری اخذ نمایندگی لطفاً فرم زیر را بصورت کامل پر کنید تا کارشناسان ما در اولین فرصت با شما تماس بگیرند.')
        }}
      </h1>
      <v-row>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label> <span class="star">*</span>{{ oracle.translate('نام و نام خانوادگی:') }}</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                v-model="vendor_owner"
                :placeholder="oracle.translate('نام و نام خانوادگی')"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label> <span class="star">*</span>{{ oracle.translate('تاریخ تولد:') }}</label>
            <v-text-field
                dir="rtl"
                solo
                placeholder="1365-01-01"
                hide-details
                v-model="vendor_owner_birth"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label> <span class="star">*</span>{{ oracle.translate('وضعیت تاهل:') }}</label>
            <!--                        <v-radio-group v-model="ex7" class="choose-item">-->
            <v-radio-group v-model="vendor_owner_marriage" class="choose-item">
              <v-radio :label="oracle.translate('متاهل')" color="#007bff" value="متاهل"></v-radio>
              <v-radio :label="oracle.translate('مجرد')" color="#007bff" value="مجرد"></v-radio>
            </v-radio-group>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label> <span class="star">*</span>{{ oracle.translate('تلفن ثابت:') }}</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                :placeholder="oracle.translate('تلفن ثابت')"
                v-model="vendor_tel"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label> <span class="star">*</span>{{ oracle.translate('موبایل:') }}</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                v-model="vendor_owner_phone"
                :placeholder="oracle.translate('موبایل')"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label> <span class="star">*</span>{{ oracle.translate('ایمیل:') }}</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                :placeholder="oracle.translate('ایمیل')"
                v-model="vendor_owner_email"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label>{{ oracle.translate('استان:') }}</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                v-model="vendor_district"
                :placeholder="oracle.translate('استان')"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label>{{ oracle.translate('شهر:') }}</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                :placeholder="oracle.translate('شهر')"
                v-model="vendor_city"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label>{{ oracle.translate('وضعیت تملک فروشگاه:') }}</label>
            <!--                        <v-radio-group v-model="ex8" class="choose-item">-->
            <v-radio-group v-model="vendor_type" class="choose-item">
              <v-radio :label="oracle.translate('مالکیت')" color="#007bff" value="مالکیت"></v-radio>
              <v-radio :label="oracle.translate('استیجاری')" color="#007bff" value="استیجاری"></v-radio>
              <v-radio :label="oracle.translate('ندارم')" color="#007bff" value="ندارم"></v-radio>
            </v-radio-group>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label>{{ oracle.translate('آدرس:') }}</label>
            <v-textarea
                dir="ltr"
                name="input-7-4"
                hide-details
                solo
                :placeholder="oracle.translate('آدرس')"
                v-model="vendor_owner_address"
            ></v-textarea>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label>{{ oracle.translate('نشانی فروشگاه مورد نظر:') }}</label>
            <v-textarea
                dir="ltr"
                name="input-7-4"
                hide-details
                solo
                v-model="vendor_address"
                :placeholder="oracle.translate('نشانی فروشگاه مورد نظر')"
            ></v-textarea>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label><span class="star">*</span>{{ oracle.translate('متراژ فروشگاه (حداقل 70 متر مربع):') }}</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                v-model="vendor_size"
                :placeholder="oracle.translate('متراژ فروشگاه')"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label>{{ oracle.translate('سوابق کاری و شغل فعلی:') }}</label>
            <v-textarea
                dir="ltr"
                name="input-7-4"
                hide-details
                solo
                v-model="vendor_experience"
                :placeholder="oracle.translate('سوابق کاری و شغل فعلی')"
            ></v-textarea>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label>{{ oracle.translate('مبلغ اجاره فروشگاه:') }}</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                :placeholder="oracle.translate('مبلغ اجاره فروشگاه')"
                v-model="vendor_rent"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="4" lg="4" md="12">
          <div class="fieldProfile">
            <label>{{ oracle.translate('نحوه آشنایی با کلانا:') }}</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                v-model="vendor_refer"
                :placeholder="oracle.translate('نحوه آشنایی با کلانا')"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="3" lg="3" md="12">
          <v-btn color="#7ec352" class="btn-submit" v-ripple role="button" @click="SetRep()">
            {{ oracle.translate('ارسال فرم درخواست نمایندگی') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-progress-circular class="mrx-auto mlx-auto messageBox" indeterminate v-else-if="loading"></v-progress-circular>
    <div v-if="disableMessage != null" class="d-flex flex-column mlx-auto mrx-auto align-center messageBox">
      <i class="mdi mdi-emoticon-sad-outline display-3 mb-5 mt-5" style="color: #7ec352"></i>
      <span style="text-align: center !important;" class="mb-5 text-center">{{ disableMessage }}</span>
    </div>
  </div>
</template>
<script>
import oracle from "@/oracle";

export default {
  name: "representation",
  components: {},
  data() {
    return {
      oracle: oracle,
      // ex7: "#007bff",
      // ex8: "#007bff",
      disableMessage: null,
      loading: true,
      vendor_owner: null,
      vendor_owner_phone: null,
      vendor_owner_birth: null,
      vendor_owner_marriage: null,
      vendor_owner_email: null,
      vendor_owner_address: null,
      vendor_district: null,
      vendor_city: null,
      vendor_address: null,
      vendor_size: null,
      vendor_refer: null,
      vendor_experience: null,
      vendor_rent: null,
      vendor_tel: null,
      vendor_type: null,
      requesting: false,
      isEN: oracle.isEN()
    };
  },
  methods: {
    SetRep() {
      if (this.requesting) return;
      if (this.vendor_tel == null || this.vendor_owner == null || this.vendor_owner_phone == null ||
          this.vendor_tel == "" || this.vendor_owner == "" || this.vendor_owner_phone == "" || this.vendor_size == null) {
        oracle.showMessage(oracle.translate('لطفا موارد ستاره دار را تکمیل نمایید.'))
        return
      }
      this.requesting = true
      oracle.axios("vendor/create",
          {
            vendor_owner: this.vendor_owner,
            vendor_owner_phone: this.vendor_owner_phone,
            vendor_owner_birth: this.vendor_owner_birth,
            vendor_owner_marriage: this.vendor_owner_marriage,
            vendor_owner_email: this.vendor_owner_email,
            vendor_owner_address: this.vendor_owner_address,
            vendor_district: this.vendor_district,
            vendor_city: this.vendor_city,
            vendor_address: this.vendor_address,
            vendor_size: this.vendor_size,
            vendor_refer: this.vendor_refer,
            vendor_experience: this.vendor_experience,
            vendor_rent: this.vendor_rent,
            vendor_tel: this.vendor_tel,
            vendor_type: this.vendor_type,
          },
          (res) => {
            this.vendor_owner = null
            this.vendor_owner_phone = null
            this.vendor_owner_birth = null
            this.vendor_owner_marriage = null
            this.vendor_owner_email = null
            this.vendor_owner_address = null
            this.vendor_district = null
            this.vendor_city = null
            this.vendor_address = null
            this.vendor_size = null
            this.vendor_refer = null
            this.vendor_experience = null
            this.vendor_rent = null
            this.vendor_tel = null
            this.vendor_type = null
            oracle.showSuccess(
                oracle.translate('فرم پذیرش با موفقیت ثبت شد')
                + '<br>'
                + oracle.translate('لطفا منتظر تماس از سمت تیم پشتیبانی باشید!') + '\n')
            this.requesting = false
          }, () => {
            this.requesting = false
          }
      );
    },
  },
  mounted() {
    oracle.axios('setting/getInfo', {filter_by: "website", search_by: 'vendor_disabled'}, (response => {
      if (response.data) {
        oracle.axios('setting/getInfo', {
          filter_by: "website",
          search_by: this.isEN ? 'vendor_disabled_text_en' : 'vendor_disabled_text'
        }, (response => {
          this.disableMessage = response.data
          this.loading = false
        }))
      } else {
        this.loading = false
        this.disableMessage = null
      }
    }))
  }
};
</script>
<style>

.representation {
  background: #fff;
}

.representation h1 {
  font-size: 14px;
  color: #333;
  margin: 30px 15px;
}

.representation .fieldProfile,
.representation .fieldArea {
  margin: 0 15px !important;
  color: #acaca8;
}

.representation .fieldProfile span {
  color: red;
  font-size: 15px;
  padding: 2px;
}

.representation .fieldProfile label {
  color: #333 !important;
  font-size: 12px;
  padding: 10px 0;
  padding-bottom: 0 !important;
}

.representation .fieldProfile {
  font-size: 12px;
  padding: 5px 0;
}

.representation .fieldProfile .v-textarea textarea {
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
}

.representation .fieldProfile .v-text-field input,
.representation .fieldProfile .vpd-input-group input,
.representation .fieldProfile .v-textarea textarea {
  font-size: 11px;
  text-align: end;
}

.representation .fieldProfile .v-text-field .v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}

.representation .fieldProfile .v-text-field .v-text-field--solo .v-input__control {
  min-height: 40px !important;
  margin: 8px 0;
}

.representation .fieldProfile .v-input--radio-group--column .v-input--radio-group__input {
  display: flex;
  flex-direction: row !important;
}

.representation .fieldProfile .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
  margin: 0;
}


.representation .fieldProfile,
.representation .fieldArea {
  margin: 0 15px !important;
  color: #acaca8;
}

.representation .fieldProfile span {
  color: red;
  font-size: 15px;
  padding: 2px;
}

.representation .fieldProfile label {
  color: #333 !important;
  font-size: 12px;
  padding-top: 20px;
  margin-top: 5px;
}

.representation .fieldProfile {
  font-size: 12px;
}

.representation .fieldProfile .v-textarea textarea {
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
}

.representation .fieldProfile .v-text-field input,
.representation .fieldProfile .vpd-input-group input,
.representation .fieldProfile .v-textarea textarea {
  font-size: 12px;
  text-align: end;
}

.representation .fieldProfile
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #ced4da;
  border-radius: 5px;
}

.representation .fieldProfile .v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px !important;
  margin: 8px 0;
}

.representation .choose-item .v-radio {
  margin: -18px 15px !important;
}

.representation .btn-submit {
  color: #fff !important;
  height: 40px !important;
  padding: 0 20px !important;
  border-radius: 3px !important;
  margin: 20px 15px !important;
}

.representation .messageBox {
  margin-top: 200px;
  margin-bottom: 200px;
}

.representation .v-radio .v-label {
  margin-top: 8px !important;
  padding: 0 !important;
  margin-right: 5px !important;
  margin-left: 5px !important;
}

.representation .star {
  color: red;
}
</style>
